import { SearchError, SearchResult } from '@ecs-services/search/search.interface';
import { createAction, props } from '@ngrx/store';
import { OrderNumberSearchResult } from '../../features/result/spare-parts-result/components/order-number-table/order-number-table.interface';
import { DataStage } from './search.reducer';

const prefix = '[Search]';

export const REQUEST_SEARCH_RESULT = `${prefix} Trigger search`;
export const requestSearchResult = createAction(
    REQUEST_SEARCH_RESULT,
    props<{ payload: { searchTerm: string[] } }>()
);

export const REQUEST_SEARCH_RESULT_ELECTRONICS = `${prefix} Trigger electronics search`;
export const requestSearchResultElectronics = createAction(
    REQUEST_SEARCH_RESULT_ELECTRONICS,
    props<{ payload: { searchTerm: string[] } }>()
);

export const REQUEST_SEARCH_RESULT_DISTINCT = `${prefix} Distinct search result request`;
export const requestSearchResultDistinct = createAction(
    REQUEST_SEARCH_RESULT_DISTINCT,
    props<{ payload: { searchTerm: string[] } }>()
);

export const RECEIVE_SEARCH_RESULT = `${prefix} Receive search result`;
export const receiveSearchResult = createAction(
    RECEIVE_SEARCH_RESULT,
    props<{
        payload: {
            searchResult: SearchResult | null;
            searchError: SearchError | null;
        };
        /**
         * If `false`, will not perform some actions/effects that get triggered by user requested results (e. g. navigation)
         */
        userRequested: boolean;
    }>()
);

export const RECEIVE_ELECTRONICS_ERROR = `${prefix} Receive Electronics search error`;
export const receiveElectronicsError = createAction(
    RECEIVE_ELECTRONICS_ERROR,
    props<{
        payload: {
            electronicsTabSearchError: SearchError | null;
        };
    }>()
);

export const RECEIVE_ORDER_NUMBER_SEARCH_RESULT = `${prefix} Receive order number search result`;
export const receiveOrderNumberSearchResult = createAction(
    RECEIVE_ORDER_NUMBER_SEARCH_RESULT,
    props<{
        payload: { orderNumberSearchResult: OrderNumberSearchResult | null | undefined };
    }>()
);

export const UPDATE_ORDER_NUMBER_ITEM_CHECKED = `${prefix} Update order number item checked flag`;
export const updateOrderNumberItemChecked = createAction(
    UPDATE_ORDER_NUMBER_ITEM_CHECKED,
    props<{
        payload: { orderNumberItemsChecked: boolean };
    }>()
);

export const UPDATE_STAGE = `${prefix} Update data stage`;
export const updateStage = createAction(UPDATE_STAGE, props<{ dataStage: DataStage }>());

export const UPDATE_SEARCH_HISTORY = `${prefix} Update search history`;
export const updateSearchHistory = createAction(
    UPDATE_SEARCH_HISTORY,
    props<{
        payload: {
            /**
             * term(s) to add to search history
             *
             * @todo clearer naming (it adds to the history, it doesn't replace); make string instead of string array (requires new "initialize" action)
             */
            searchHistory: string[];
        };
        /**
         * whether to initialize search history or not
         *
         * @todo rename to "initialize" (will be obsolete when initializing has its own action)
         */
        initial: boolean;
    }>()
);

export const UPDATE_SEARCH_ERROR = `${prefix} Update search error`;
export const updateSearchError = createAction(
    UPDATE_SEARCH_ERROR,
    props<{ payload: { searchError: SearchError | null } }>()
);

/**
 * Dispatched when we actually don't want to do/change anything.
 * Used as fallback when conditionally returning actions in
 * effects in cases where we usually wouldn't want to dispatch an action.
 */
export const NO_OP = 'Do nothing';
/**
 * @see NO_OP
 */
export const noOpAction = createAction(NO_OP);
